module.exports = __webpack_public_path__ + "assets/img/home3-box3-img5.c249f15e.png";